import type { AgentInteractionThinkingStep, ThinkingStep } from '@Models';

/** Appends a model note unless it repeats the previous one; returns the same array when skipped. */
export const appendThinkingStep = (steps: ThinkingStep[], step: ThinkingStep): ThinkingStep[] => {
  const last = steps[steps.length - 1];
  if (last && last.label === step.label) return steps;
  return [...steps, step];
};

/** Maps persisted steps to UI steps, skipping empty and repeated notes. */
export const fromApiThinkingSteps = (raw: AgentInteractionThinkingStep[] | null | undefined): ThinkingStep[] => {
  if (!raw || raw.length === 0) return [];
  return raw.reduce<ThinkingStep[]>((acc, item) => {
    const label = item.text?.trim() ?? '';
    return label ? appendThinkingStep(acc, { label, tMs: item.t_ms ?? 0 }) : acc;
  }, []);
};

/** Inverse of fromApiThinkingSteps, used to stamp a finished turn into the interactions cache. */
export const toApiThinkingSteps = (steps: ThinkingStep[]): AgentInteractionThinkingStep[] =>
  steps.map((step) => ({ kind: 'progress', text: step.label, t_ms: step.tMs }));
